import { CoordinatesType, CursorTrackerType } from './popover.types';

export const CursorTracker = {
  getInstance(): CursorTrackerType {
    let coordinates: CoordinatesType = { x: 0, y: 0 };
    function onMouseMove(e: MouseEvent) {
      try {
        coordinates = { x: e.clientX, y: e.clientY };
      } catch (error) {
        // just accessing event properties can throw an exception in some rare circumstances
      }
    }
    window.addEventListener('mousemove', onMouseMove);

    return {
      getCursorPosition() {
        return coordinates;
      },
      removeListener() {
        window.removeEventListener('mousemove', onMouseMove);
      },
    };
  },
};
